import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { NoAccessPage } from './NoAccessPage';

/**
 * Страница только для администратора. Сотрудник, открывший адрес вручную, видит понятный экран,
 * а сама страница не создаётся, поэтому админские запросы не отправляются.
 */
export function withAdminOnly<P extends object>(Page: React.ComponentType<P>): React.FC<P> {
  const Guarded: React.FC<P> = (props) => {
    const { isAdmin } = useAuth();
    return isAdmin ? <Page {...props} /> : <NoAccessPage />;
  };
  Guarded.displayName = `AdminOnly(${Page.displayName || Page.name || 'Page'})`;
  return Guarded;
}
